<template>
  <div class="dashboard-layout">
    <!-- Sidebar for Desktop -->
    <Sidebar v-if="!hideSidebar" class="desktop-sidebar" />
    
    <!-- Mobile Header -->
    <div class="mobile-header">
      <button v-if="!hideSidebar" @click="toggleMobileSidebar" class="menu-toggle">
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="header-logo" :class="{ 'centered': hideSidebar }">
        <img src="@/assets/berts-logo-header.png" alt="Bert Points" class="logo" />
      </div>
    </div>

    <!-- Mobile Sidebar Overlay -->
    <div 
      v-if="!hideSidebar"
      class="mobile-sidebar-overlay" 
      :class="{ 'active': isMobileSidebarOpen }"
      @click="closeMobileSidebar"
    >
      <Sidebar 
        class="mobile-sidebar" 
        :class="{ 'open': isMobileSidebarOpen }"
      />
    </div>

    <!-- Main Content Area -->
    <div class="main-content" :class="{ 'no-sidebar': hideSidebar }">
      <div class="content-wrapper">
        <slot></slot>
      </div>
    </div>

    <!-- Bottom Navigation for Mobile -->
    <BottomNavigation v-if="!hideSidebar" class="mobile-bottom-nav" />
  </div>
</template>

<script>
import DashboardSidebar from './Sidebar.vue';
import MobileBottomNavigation from './BottomNavigation.vue';

export default {
  name: "AppDashboardLayout",
  components: {
    Sidebar: DashboardSidebar,
    BottomNavigation: MobileBottomNavigation
  },
  props: {
    hideSidebar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobileSidebarOpen: false,
      hasNotifications: true // You can make this dynamic based on actual notifications
    };
  },
  methods: {
    toggleMobileSidebar() {
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    },
    
    closeMobileSidebar() {
      this.isMobileSidebarOpen = false;
    }
  },
  mounted() {
    // Close mobile sidebar when route changes
    this.$router.afterEach(() => {
      this.isMobileSidebarOpen = false;
    });
  }
};
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: white;
}

/* Desktop Sidebar */
.desktop-sidebar {
  display: block;
}

/* Mobile Header */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: white;
  border-bottom: 1px solid #e9ecef;
  z-index: 1001;
  padding: 0 1rem;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.menu-toggle {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #495057;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.menu-toggle:hover {
  background: #f8f9fa;
}

.header-logo {
  flex: 1;
  display: flex;
  justify-content: center;
}

.logo {
  height: 35px;
  width: auto;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification-btn {
  background: none;
  border: none;
  font-size: 1.3rem;
  color: #495057;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  position: relative;
  transition: background 0.3s ease;
}

.notification-btn:hover {
  background: #f8f9fa;
}

.notification-badge {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: #dc3545;
  color: white;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.4rem;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  line-height: 1;
}

/* Mobile Sidebar */
.mobile-sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-sidebar-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-sidebar {
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.mobile-sidebar.open {
  transform: translateX(0);
}

/* Main Content */
.main-content {
  flex: 1;
  margin-left: 280px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content.no-sidebar {
  margin-left: 0;
}

.content-wrapper {
  flex: 1;
}

/* Mobile Header Logo Centering */
.header-logo.centered {
  justify-content: flex-start;
  padding-left: 1rem;
}

/* Mobile Bottom Navigation */
.mobile-bottom-nav {
  display: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .desktop-sidebar {
    display: none;
  }
  
  .mobile-header {
    display: flex;
  }
  
  .mobile-sidebar-overlay {
    display: block;
  }
  
  .mobile-bottom-nav {
    display: block;
  }
  
  .main-content {
    margin-left: 0;
    padding-top: 60px;
    padding-bottom: 80px;
  }
  
  .main-content.no-sidebar {
    padding-bottom: 0;
  }
}

/* Smooth transitions */
* {
  box-sizing: border-box;
}

/* Prevent body scroll when mobile sidebar is open */
body.sidebar-open {
  overflow: hidden;
}
</style>